import React from 'react';
import { ArrowLeft, Home, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui';

interface PermissionDeniedProps {
  title?: string;
  message?: string;
  showBackButton?: boolean;
  showHomeButton?: boolean;
}

const PermissionDenied: React.FC<PermissionDeniedProps> = ({
  title = 'Almost There!',
  message = 'This area requires special permissions to access. No worries - your administrator can help you get the access you need!',
  showBackButton = true,
  showHomeButton = true,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/dashboard/home');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          {/* Icon */}
          <div className="mx-auto w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6 shadow-lg">
            <Lock className="w-12 h-12 text-blue-600" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-800 mb-4">{title}</h1>

          {/* Message */}
          <p className="text-gray-600 leading-relaxed mb-8 text-lg">
            {message}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          {showHomeButton && (
            <Button
              onClick={handleGoHome}
              variant="primary"
              className="w-full"
              startIcon={<Home size={18} />}
            >
              Go to Dashboard
            </Button>
          )}

          {showBackButton && (
            <Button
              onClick={handleBack}
              variant="outline"
              className="w-full"
              startIcon={<ArrowLeft size={18} />}
            >
              Go Back
            </Button>
          )}
        </div>

        {/* Help Text */}
        <div className="mt-8 pt-6 border-t border-blue-100">
          <p className="text-sm text-gray-600">
            🤝 Need help getting access? Your administrator or school's WhatsApp
            support team is ready to assist you!
          </p>
        </div>
      </div>
    </div>
  );
};

export default PermissionDenied;
